export default [
  {  path: '/notfound',  component: () => import('./components/NotFound.vue')},
  //{  path: '/home',  component: () => import('./components/page/home.vue')},

  {  path: '/user',  component: () => import('./components/page/user/userPage.vue')},
  {  path: '/userprofile/:id', component: ()  => import('./components/page/user/profilePage.vue'),props: true},

  {  path: '/permission',  component: () => import('./components/page/permission/PermPage.vue')},

  {  path: '/work',  component: () => import('./components/page/admin/WorkPage.vue')},

  {  path: '/brand',  component: () => import('./components/page/admin/BrandPage.vue')},

  {  path: '/cool',  component: () => import('./components/page/admin/CoolPage.vue')},

  {  path: '/stock',  component: () => import('./components/page/admin/StockPage.vue')},

  {  path: '/option',  component: () => import('./components/page/admin/OptionPage.vue')},

  {  path: '/filial',  component: () => import('./components/page/admin/FilialPage.vue')},

  {  path: '/price',  component: () => import('./components/page/admin/PricePage.vue')},
  {  path: '/price/:id', component: ()  => import('./components/page/admin/PricePage.vue'),props: true},
  {  path: '/history/:id', component: ()  => import('./components/page/admin/HistoryPage.vue'),props: true},
  {  path: '/print/:id', component: ()  => import('./components/page/PrintInPage.vue'),props: true},
  {  path: '/printout/:id', component: ()  => import('./components/page/PrintOutPage.vue'),props: true},


  // {  path: '/about', component: ()  => import('./components/page/site/index.vue')},

  // {  path: '/:pathMatch(.*)*', name: '404', component: NotFoundView}

];